import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, PencilIcon, CheckIcon, XIcon } from 'lucide-react';
const PropertyDetailsPage = () => {
  // Sample data for Castle Apartments
  const [propertyAttributes, setPropertyAttributes] = useState([{
    id: 1,
    name: 'Pool',
    value: '2',
    dataType: 'Number'
  }, {
    id: 2,
    name: 'Grills',
    value: '6',
    dataType: 'Number'
  }, {
    id: 3,
    name: 'Elevator',
    value: 'Service and Passenger',
    dataType: 'Text'
  }, {
    id: 4,
    name: 'Construction Date',
    value: '2026-03-15',
    dataType: 'Date'
  }, {
    id: 5,
    name: 'Rooftop Access',
    value: 'Outside Access',
    dataType: 'List: Outside Access, Inside Access'
  }, {
    id: 6,
    name: 'Parking Spaces',
    value: '120',
    dataType: 'Number'
  }, {
    id: 7,
    name: 'Security System',
    value: 'Yes',
    dataType: 'Yes/No'
  }, {
    id: 8,
    name: 'Fitness Center',
    value: 'Yes',
    dataType: 'Yes/No'
  }, {
    id: 9,
    name: 'Pet Friendly',
    value: 'Yes',
    dataType: 'Yes/No'
  }]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedValue, setEditedValue] = useState('');
  // Function to get style class based on data type
  const getDataTypeColorClass = dataType => {
    if (dataType.startsWith('Yes/No')) {
      return 'bg-green-50 text-green-700';
    } else if (dataType.startsWith('Number')) {
      return 'bg-blue-50 text-blue-700';
    } else if (dataType.startsWith('Text')) {
      return 'bg-purple-50 text-purple-700';
    } else if (dataType.startsWith('Date')) {
      return 'bg-amber-50 text-amber-700';
    } else if (dataType.startsWith('List')) {
      return 'bg-indigo-50 text-indigo-700';
    } else {
      return 'bg-gray-50 text-gray-700';
    }
  };
  // Function to format dates for display
  const formatDate = dateString => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  const handleEditClick = attribute => {
    setEditingRowId(attribute.id);
    setEditedValue(attribute.value);
  };
  const handleSave = attributeId => {
    setPropertyAttributes(propertyAttributes.map(attr => attr.id === attributeId ? {
      ...attr,
      value: editedValue
    } : attr));
    setEditingRowId(null);
    setEditedValue('');
  };
  const handleCancel = () => {
    setEditingRowId(null);
    setEditedValue('');
  };
  const renderEditableValue = attribute => {
    if (editingRowId !== attribute.id) {
      return <span data-id="element-262">
          {attribute.dataType === 'Date' ? formatDate(attribute.value) : attribute.value}
        </span>;
    }
    // Render appropriate input based on data type
    if (attribute.dataType === 'Yes/No') {
      return <select value={editedValue} onChange={e => setEditedValue(e.target.value)} className="block w-full border border-blue-300 rounded-md shadow-sm py-1 px-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" autoFocus data-id="element-263">
          <option value="Yes" data-id="element-264">Yes</option>
          <option value="No" data-id="element-265">No</option>
        </select>;
    } else if (attribute.dataType === 'Number') {
      return <input type="number" value={editedValue} onChange={e => setEditedValue(e.target.value)} className="block w-full border border-blue-300 rounded-md shadow-sm py-1 px-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" autoFocus data-id="element-266" />;
    } else if (attribute.dataType === 'Date') {
      return <input type="date" value={editedValue} onChange={e => setEditedValue(e.target.value)} className="block w-full border border-blue-300 rounded-md shadow-sm py-1 px-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" autoFocus data-id="element-267" />;
    } else if (attribute.dataType.startsWith('List')) {
      const listItems = attribute.dataType.substring(6).split(',').map(item => item.trim());
      return <select value={editedValue} onChange={e => setEditedValue(e.target.value)} className="block w-full border border-blue-300 rounded-md shadow-sm py-1 px-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" autoFocus data-id="element-268">
          {listItems.map((item, idx) => <option key={idx} value={item} data-id="element-269">
              {item}
            </option>)}
        </select>;
    } else {
      // Text input
      return <input type="text" value={editedValue} onChange={e => setEditedValue(e.target.value)} className="block w-full border border-blue-300 rounded-md shadow-sm py-1 px-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" autoFocus data-id="element-270" />;
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-271">
      <header className="bg-white shadow" data-id="element-272">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-273">
          <div className="flex justify-between items-center" data-id="element-274">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-275">
              Castle Apartments
            </h1>
            <div className="flex space-x-3" data-id="element-276">
              <Link to="/" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-opacity" style={{
              backgroundColor: '#332275'
            }} data-id="element-277">
                Reports
              </Link>
              <Link to="/settings" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-opacity" style={{
              backgroundColor: '#332275'
            }} data-id="element-278">
                Settings
              </Link>
            </div>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-279">
        {/* Property Information Card */}
        <div className="bg-white shadow rounded-lg p-6 mb-8" data-id="element-280">
          <div className="flex justify-between items-start mb-4" data-id="element-281">
            <h2 className="text-xl font-semibold text-gray-800" data-id="element-282">
              Property Information
            </h2>
            <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-medium bg-green-100 text-green-800" data-id="element-283">
              Last Synced to Salesforce: 10:32am
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-284">
            <div data-id="element-285">
              <p className="text-sm text-gray-500" data-id="element-286">Address</p>
              <p className="font-medium" data-id="element-287">123 Castle Street</p>
              <p data-id="element-288">New York, NY 10001</p>
            </div>
            <div data-id="element-289">
              <p className="text-sm text-gray-500" data-id="element-290">Management</p>
              <p className="font-medium" data-id="element-291">Greystar</p>
              <p data-id="element-292">Since January 2018</p>
            </div>
            <div data-id="element-293">
              <p className="text-sm text-gray-500" data-id="element-294">Units</p>
              <p className="font-medium" data-id="element-295">245 Residential Units</p>
              <p data-id="element-296">5 Commercial Spaces</p>
            </div>
          </div>
        </div>
        {/* Property Attributes Table */}
        <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-297">
          <div className="px-6 py-4 border-b border-gray-200" data-id="element-298">
            <h2 className="text-xl font-semibold text-gray-800" data-id="element-299">
              Property Attributes
            </h2>
            <p className="text-sm text-gray-600 mt-1" data-id="element-300">
              Castle Apartment Homes - 123 Castle Street New York, NY 10001 -
              245 Residential Units
            </p>
          </div>
          <div className="overflow-x-auto" data-id="element-301">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-302">
              <thead className="bg-gray-50" data-id="element-303">
                <tr data-id="element-304">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-305">
                    Attribute
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-306">
                    Value
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-307">
                    Data Type
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-308">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-309">
                {propertyAttributes.map(attribute => <tr key={attribute.id} className={editingRowId === attribute.id ? 'bg-blue-50' : 'hover:bg-gray-50'} data-id="element-310">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-311">
                      {attribute.name}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500" data-id="element-312">
                      {renderEditableValue(attribute)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-313">
                      <span className={`px-2 py-1 rounded-md text-xs font-medium ${getDataTypeColorClass(attribute.dataType)}`} data-id="element-314">
                        {attribute.dataType.startsWith('List') ? 'List' : attribute.dataType}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-315">
                      {editingRowId === attribute.id ? <div className="flex items-center space-x-2" data-id="element-316">
                          <button onClick={() => handleSave(attribute.id)} className="inline-flex items-center p-1 border border-transparent rounded-md text-green-600 hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" title="Save" data-id="element-317">
                            <CheckIcon className="h-5 w-5" data-id="element-318" />
                          </button>
                          <button onClick={handleCancel} className="inline-flex items-center p-1 border border-transparent rounded-md text-gray-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" title="Cancel" data-id="element-319">
                            <XIcon className="h-5 w-5" data-id="element-320" />
                          </button>
                        </div> : <button onClick={() => handleEditClick(attribute)} className="inline-flex items-center p-1 border border-transparent rounded-md text-gray-400 hover:text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" title="Edit" data-id="element-321">
                          <PencilIcon className="h-4 w-4" data-id="element-322" />
                        </button>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>;
};
export default PropertyDetailsPage;